import { Award, CheckCircle2, ShieldCheck, Users } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function About() {
  const { settings } = useSettings();

  const stats = [
    { icon: ShieldCheck, label: "Licensed & Insured" },
    { icon: Award, label: "Code Compliant" },
    { icon: Users, label: "Family Operated" },
    { icon: CheckCircle2, label: "Satisfaction Guaranteed" },
  ];

  return (
    <section id="about" className="relative py-24 lg:py-32 bg-[#080809] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6">
          <div className="text-xs uppercase tracking-[0.28em] text-yellow-400 font-bold mb-4">Who We Are</div>
          <h2 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] mb-7">
            Wired for trust.<br />Built on <span className="text-yellow-400">craft</span>.
          </h2>
          <p className="text-white/70 text-base lg:text-lg leading-relaxed mb-6">
            {settings?.about ||
              "B&J Electric Service LLC is a licensed and insured electrical contractor serving the entire DMV area. From EV charger installations to full-home rewiring, we deliver honest, on-time, and code-compliant work — every job, every time."}
          </p>
          <p className="text-white/60 leading-relaxed">
            We treat every home like ours and every project like it matters — because it does. Clean job sites, transparent pricing, and no shortcuts on safety.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="flex items-center gap-3 border border-white/10 rounded-md px-4 py-3.5 hover:border-yellow-400/40 hover:bg-white/[0.02] transition-all"
                data-testid={`trust-badge-${s.label.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
              >
                <s.icon className="w-5 h-5 text-blue-500" strokeWidth={1.5} />
                <span className="text-sm text-white/85 font-medium">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="relative">
            <div className="absolute -inset-4 bg-blue-500/10 blur-3xl rounded-3xl" />
            <div className="relative grid grid-cols-2 gap-4">
              <div className="col-span-2 aspect-[16/9] rounded-xl overflow-hidden border border-white/10">
                <img
                  src="https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjBvbiUyMHBhbmVsfGVufDB8fHx8MTc4Mzk4NjA4NXww&ixlib=rb-4.1.0&q=85"
                  alt="Electrician working"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="aspect-square rounded-xl overflow-hidden border border-white/10">
                <img
                  src="https://images.unsplash.com/photo-1593941707882-a5bba14938c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxFViUyMGNoYXJnZXIlMjBpbnN0YWxsYXRpb258ZW58MHx8fHwxNzgzOTg2MDg1fDA&ixlib=rb-4.1.0&q=85"
                  alt="EV charger"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="aspect-square rounded-xl overflow-hidden border border-white/10 bg-yellow-400 flex flex-col justify-between p-5">
                <div className="text-black font-display font-black text-5xl lg:text-6xl leading-none">15+</div>
                <div className="text-black/80 text-xs uppercase tracking-[0.22em] font-bold">Years serving<br />the DMV</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
